// Parses the SkillTreeTable awakening grammar for _SubSkillTableID and
// _SkillConditionID. Both columns can ship as INT (legacy: single integer)
// or as TEXT (current: a small grammar that supports multiple awakening
// choices and PvE/PvP-specific IDs in one row).
//
// Grammar:
//   field := entry ( ";" entry )*
//   entry := pveId [ "," pvpId ]
// pvpId defaults to pveId; <=0 on either side means "no awakening this side".
// Canonical reference: D:\git\projectduck\source\wiki\arch\awakening-skills.md

export interface IAwakeningPair {
    conditionId: number;
    awakenedId: number;
}

export interface IAwakeningEntry {
    pve: number;
    pvp: number;
}

export function parseAwakeningField(raw: string | number | null | undefined): IAwakeningEntry[] {
    if (raw === null || raw === undefined || raw === '') {
        return [];
    }
    if (typeof raw === 'number') {
        return [{ pve: raw, pvp: raw }];
    }

    return raw.split(';').map((entry) => {
        const parts = entry.split(',');
        const pve = Number(parts[0]) || 0;
        const pvp = parts.length > 1 ? (Number(parts[1]) || 0) : pve;
        return { pve, pvp };
    });
}

function pickSide(entry: IAwakeningEntry, pvp: boolean): number {
    return pvp ? entry.pvp : entry.pve;
}

export function pairAwakenings(
    conditionRaw: string | number | null | undefined,
    subRaw: string | number | null | undefined,
    pvp: boolean,
): IAwakeningPair[] {
    const cond = parseAwakeningField(conditionRaw);
    const sub = parseAwakeningField(subRaw);
    const len = Math.min(cond.length, sub.length);
    const ret: IAwakeningPair[] = [];
    for (let i = 0; i < len; i++) {
        const conditionId = pickSide(cond[i], pvp);
        const awakenedId = pickSide(sub[i], pvp);
        if (conditionId > 0 && awakenedId > 0) {
            ret.push({ conditionId, awakenedId });
        }
    }
    return ret;
}

export function firstAwakening(
    conditionRaw: string | number | null | undefined,
    subRaw: string | number | null | undefined,
    pvp: boolean,
): IAwakeningPair | null {
    const pairs = pairAwakenings(conditionRaw, subRaw, pvp);
    return pairs.length > 0 ? pairs[0] : null;
}
